import { useState, useEffect, useContext, useRef } from "react";
import LocationDot from "/packages/icons/location-dot.svg";
import Parking from "/packages/icons/parking.svg";
import Phone from "/packages/icons/phone.svg";
import Clock from "/packages/icons/clock.svg";
import ChevronDown from "/packages/icons/chevron-down.svg";
import ChevronUp from "/packages/icons/chevron-up.svg";
import Link from "next/link";
import { convertTo12HourFormat } from "../../utils/formatTime";
import Button from "../Button";
import StoreContext from "../../context/store";
import { useShoppingCart } from "../../context/cart";
import Image from "next/image";
import { useRouter } from "next/router";

export default function PickupLocation({ store: selectedStore, showVirtualButton = true }) {
  const router = useRouter();
  const [showAllHours, setShowAllHours] = useState(false);
  const [dayOfWeek, setDayOfWeek] = useState("");
  const { store, setStore, setStoreName, setOrderType, pickupStores } = useContext(StoreContext);
  const { setCartItems } = useShoppingCart();
  const [userStore, setUserStore] = useState();
  const slug = selectedStore.url_slug
    .replace("purple-lotus-san-jose-", "")
    .replace("-pickup", "")
    .toLowerCase();

  useEffect(() => {
    setUserStore(store);
  }, [store]);

  const getDayOfWeek = () => {
    const today = new Date();
    const options = { weekday: "long" };
    return new Intl.DateTimeFormat("en-US", options).format(today);
  };

  useEffect(() => {
    const day = getDayOfWeek();
    setDayOfWeek(day);
  }, []);


  const storeName = selectedStore?.name.includes('(')
    ? selectedStore.name.match(/\(([^)]+)\)/)[1] // Extract content inside parentheses
    : selectedStore?.name.replace("Purple Lotus - ", ""); // Remove "Purple Lotus - " if no parentheses

  const [tooltipText, setTooltipText] = useState('Click to copy');
  const addressRef = useRef(null);

  const handleCopyClick = () => {
    navigator.clipboard.writeText(selectedStore.address + ', ' + selectedStore.city + ', CA ' + selectedStore.zip);
    setTooltipText('Copied!');
  };

  return (

    <div className="flex bg-neutral-100 br-300" style={{
      border: "1px solid rgb(218 218 218)", flexDirection: "column", overflow: "hidden", height: "fit-content",
    }}>

      {selectedStore.primary_gallery_image &&
        <Link href={`/pickup/${slug}`} style={{ objectFit: "cover", position: 'relative', height: "166px" }}>
          <Image
            src={selectedStore.primary_gallery_image}
            alt={selectedStore.name}
            fill
            style={{ objectFit: "cover" }}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          /></Link>
      }

      <div className="p-150">

        <span style={{ fontSize: "0.875rem", fontWeight: '600', opacity: "0.7", textTransform: "uppercase" }}>{selectedStore.city} <br /></span>
        <h2 className="pb-1 fs-600 relative" style={{ lineHeight: "1.875rem" }}>
          {storeName}
        </h2>

        {/* todo use this when we update our Jane store names */}
        {/* <h2>{selectedStore.name}</h2> */}

        {selectedStore &&
          <div className="flex gap-100 w-100" style={{
            justifyContent: "space-between",
            flexDirection: "column",
          }}>
            <div className="flex-column gap-50">

              <div className="flex gap">
                <LocationDot className="icon" />
                <span
                  className="address"
                  ref={addressRef}
                  onClick={handleCopyClick}
                  onMouseEnter={() => setTooltipText('Click to copy')}
                  onMouseLeave={() => setTooltipText('Click to copy')}
                  style={{ cursor: 'pointer' }}
                >
                  {selectedStore.address}
                  <br />
                  {selectedStore.city}, CA {selectedStore.zip}
                  <span className="copyTooltip">{tooltipText}</span>
                </span>
              </div>

              <div>
                <Link href={`tel:${selectedStore.phone}`} alt="call us" className="link flex align-center gap">
                  <Phone className="icon" />{selectedStore.phone}
                </Link>
              </div>

              <div>
                <Link href={`/pickup/${slug}#parking`} alt="parking options" className="link flex align-center gap">
                  <Parking className="icon" />Parking
                </Link>
              </div>

              <div className="flex gap">
                <Clock className="icon" style={{ paddingTop: '2px' }} />
                <div className="flex-column w-100">

                  <div className="hours">
                    {selectedStore.pickup_hours.map((i, index) => {
                      if (
                        showAllHours ||
                        i.day.toLowerCase() === dayOfWeek.toLowerCase()
                      ) {
                        return (
                          <div
                            key={index}
                            className={`day ${i.day.toLowerCase() === dayOfWeek.toLowerCase() &&
                              showAllHours
                              ? "today"
                              : undefined
                              }`}
                          >
                            <span>{i.day}</span>
                            <div>
                              {convertTo12HourFormat(i.period.from)} -{" "}
                              {convertTo12HourFormat(i.period.to)}
                            </div>
                          </div>
                        );
                      }
                      return null;
                    })}
                  </div>

                  {/* TODO fix flex for proper clock icon placement and spacing */}
                  <div
                    className="link pt-50 fs-300 text-right flex align-center gap"
                    style={{ justifyContent: "flex-end" }}
                    role="button"
                    onClick={() => setShowAllHours(!showAllHours)}
                  >
                    {showAllHours ? "View Less" : "View all hours"}
                    {showAllHours ? <ChevronUp className="fs-200" /> : <ChevronDown className="fs-200" />}
                  </div>
                </div>
              </div>
            </div>

            {showVirtualButton && <Button type="link" href={`/pickup/${slug}`} className="text-center w-100">
              Virtual Tour
            </Button>}

            <Button
              type="button"
              onClick={() => {
                router.push("/shop");
                setStore(selectedStore.id)
                setStoreName(selectedStore.address)
                setOrderType("Pickup")
                // if (selectedStore !== selectedStore.id) {
                //   setCartItems([]);
                //   window.pendingCart = [];
                // }
              }
              }

              alt="shop pickup"
              className="text-center w-100 primary"
            >
              Order Pickup
            </Button>

          </div>
        }
      </div>
    </div>
  );
}
